import React from 'react'
import SmartRatesWrapper from '../SmartRatesWrapper'
import { shallow } from 'enzyme'

describe('<SmartRatesWrapper />', () => {
  let wrapper, instance
  beforeEach(() => {
    wrapper = shallow(<SmartRatesWrapper />)
    instance = wrapper.instance()
  })
  describe('#unhideLoansTable', () => {
    let loansTable
    beforeEach(() => {
      loansTable = global.document.createElement('div')
      loansTable.setAttribute('id', 'loans-table')
      loansTable.style.display = 'none'
      global.document.querySelector('body').appendChild(loansTable)
    })
    it('should change the loans table\'s display from "none" to "table"', () => {
      instance.unhideLoansTable()
      expect(loansTable.style.display).toBe('table')
    })
  })
  describe('#componentDidCatch', () => {
    it('should call #unhideLoansTable()', () => {
      instance.unhideLoansTable = jest.fn()
      instance.componentDidCatch()
      expect(instance.unhideLoansTable).toHaveBeenCalledTimes(1)
    })
  })
})
